import classnames from 'classnames';
import type { ReactElement, ReactNode } from 'react';
import styles from './Tabs.module.scss';

type TabGroupProps = {
  children: ReactNode;
  className?: string;
};

export function TabGroup(props: TabGroupProps): ReactElement {
  return (
    <div className={classnames(styles.tabGroup, props.className)}>
      {props.children}
    </div>
  );
}
